import { colors } from '@lmc/common/constants'
// @ts-ignore
import { hexToRgbA } from '@lmc/common/utils'
import React, { type ReactElement } from 'react'
import { Link } from 'react-router-dom'
import Badge from '../../../../dataDisplay/Badge'

export type EmarResidentMedicationCellProps = {
  controlledDrug?: boolean
  customName?: string
  id: string
  medication?: { name: string }
  PRN?: boolean
  resident?: string
  testId?: string
}

export default function EmarResidentMedicationCell({
  PRN,
  controlledDrug,
  customName,
  id,
  medication,
  resident,
  testId
}: EmarResidentMedicationCellProps): ReactElement {
  return (
    <div
      data-testid={
        testId ? `${testId}-emar-medication-cell` : 'emar-medication-cell'
      }
    >
      <div
        style={styles.container}
        data-testid={testId ? `${testId}-medication-info` : 'medication-info'}
      >
        <Link
          to={`/residents/${resident}/emar/${id}/stock`}
          data-testid={testId ? `${testId}-medication-link` : 'medication-link'}
        >
          <span style={styles.blackText}>
            {customName || (medication && medication.name)}
          </span>
        </Link>
        {controlledDrug && (
          <Badge
            color={hexToRgbA(colors.red, 0.2)}
            cornerType="square"
            style={styles.badge}
            text="CD"
            textColor={colors.red}
          />
        )}
        {PRN && (
          <Badge
            color={hexToRgbA(colors.blue, 0.2)}
            cornerType="square"
            style={styles.badge}
            text="PRN"
            textColor={colors.blue}
          />
        )}
      </div>
    </div>
  )
}

const styles = {
  container: {
    paddingTop: 3,
    display: 'flex'
  },
  badge: {
    fontSize: 12,
    height: 25,
    fontWeight: 'bold',
    marginLeft: 8,
    padding: '4px',
    borderRadius: 15
  },
  blackText: {
    color: colors.black
  }
}
